<template>
	<el-dialog :visible.sync="showModal" center class="sf-message" :showClose="false" :modal="false" :close-on-click-modal="false">
		<span slot="title" class="dialog-title" style="font-size: 80px">
			<span class="session-modal__title">{{ remainingTime_(screenCounter) }}</span>
			<!-- 다국어: 장시간 미사용으로 인해 곧 로그아웃 됩니다. -->
			<span>{{ getMessage_('SWCC000760') }}</span>
		</span>
	</el-dialog>
</template>

<script>
//장기 미사용으로 인한 로그아웃 경고 창
import { rootComputed, rootMethods } from '@/store/common/helpers';
export default {
	computed: {
		...rootComputed,

		//팝업 창 노출 여부
		showModal() {
			return 0 < this.screenCounter && this.screenCounter < 60; //화면 장기 미사용 체크 카운터가 1분 이하로 남았을 때 화면 표출
		}
	},

	methods: {
		...rootMethods,

		initModal() {
			this.defaultAssign_({ key: 'isLogout', value: false });
		}
	}
};
</script>

<style></style>
